import { h } from "preact";
import { useDispatch, useSelector } from "react-redux";
import { classNames } from "../helpers";
import i18n from "../i18n";

import {
  selectIsLoggedIn,
  selectSeeingCompanyPages,
  setShowMobileMenu,
} from "../store";

import Button from "./Button.jsx";
import Icon from "./Icon.jsx";
import List from "./List.jsx";
import ListItem from "./ListItem.jsx";
import { useEffect } from "preact/hooks";
import { getNaviDrawerLinks } from "../services/navigationLinks";

export default function NaviDrawer({ previewMode }) {
  const dispatch = useDispatch();
  const isOpen = useSelector((state) => state.ui.showMobileMenu);
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const seeingCompanyPages = useSelector(selectSeeingCompanyPages);
  const links = getNaviDrawerLinks(seeingCompanyPages, isLoggedIn, previewMode);

  const handleLogoutClick = async (event) => {
    event.preventDefault();
    window.location.href = "/logout";
  };

  useEffect(() => {
    if (isOpen) {
      document.body.parentNode.classList.add("scroll-fixed");
    } else {
      document.body.parentNode.classList.remove("scroll-fixed");
    }
  }, [isOpen]);

  return (
    <div class={classNames("navi-drawer", isOpen && "navi-drawer--open")}>
      <div class="navi-drawer__top">
        <a class="navi-drawer__logo" href="/">
          <img
            src="/images/logo.svg"
            width="92"
            height="36"
            alt="Nioomi Home"
          />
        </a>
        <Icon
          class="navi-drawer__closer"
          onClick={() => {
            dispatch(setShowMobileMenu(false));
          }}
        >
          close
        </Icon>
      </div>

      <div class="navi-drawer__content">
        {!isLoggedIn && (
          <div class="navi-drawer__actions">
            <Button large secondary href="/login" target="_self">
              {i18n.t("navi_drawer.login")}
            </Button>
            <Button
              large
              to={previewMode ? "/registration" : null}
              href={!previewMode ? "/register" : null}
              target="_self"
            >
              {i18n.t("navi_drawer.register")}
            </Button>
          </div>
        )}

        <List class="navi-drawer__links">
          {links.map((item) => (
            <ListItem
              class="navi-drawer__link"
              iconFront={
                <Icon style={`color: ${item.iconColor}`}>{item.icon}</Icon>
              }
              to={item.href}
              onClick={() => {
                dispatch(setShowMobileMenu(false));
              }}
            >
              {item.alt}
            </ListItem>
          ))}
        </List>

        <div class="navi-drawer__bottom">
          <div class="navi-drawer__footer">
            {isLoggedIn && (
              <Button
                large
                text
                class="mr-0 subtle navi-drawer__logout"
                href="/logout"
                onClick={handleLogoutClick}
              >
                {i18n.t("navi_drawer.logout")}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
